import { Button, Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { enableProfilePageExplorerLinks } from 'config/env'
import { GIFT_PAGE } from 'utils/paths'
import GiftAnalysisCause from './components/GiftAnalysisCause'
import GiftAnalysisRegion from './components/GiftAnalysisRegion'
import GiftAnalysis from './components/GiftAnalysis'

import { ReactComponent as Logo } from 'assets/logo-triangle.svg'

const ProfileGifts = () => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  return (
    <Grid container>
      <Grid size={{ xl: 3, lg: 3, md: 4, sm: 12, xs: 12 }}>
        <div className="profile-page-charts-container">
          {enableProfilePageExplorerLinks && (
            <div className="profile-page-explorer-link">
              <div className="profile-page-explorer-logo">
                <Logo />
              </div>
              <span>
                <span>{t.funder.giftExplorerPrompt}</span>
                <Link to={GIFT_PAGE}>
                  <Button variant="contained">{t.explorer.title}</Button>
                </Link>
              </span>
            </div>
          )}
          <GiftAnalysisCause />
          <GiftAnalysisRegion />
        </div>
      </Grid>
      <Grid size={{ xl: 9, lg: 9, md: 8, sm: 12, xs: 12 }}>
        <GiftAnalysis />
      </Grid>
    </Grid>
  )
}

ProfileGifts.isEnabled = ({ isFunderDissolved, hasGifts }) => !isFunderDissolved && hasGifts
ProfileGifts.tabPath = 'giftanalysis'
ProfileGifts.getTabName = t => t.funder.giftAnalysis

export default ProfileGifts
